// 現在ユーザーのコンテキスト。/api/me で解決する。
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, ApiError } from "./lib/api";
import type { User } from "./lib/types";

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  devLoginAvailable: boolean;
  reload: () => void;
}

const AuthContext = createContext<AuthState | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [devLoginAvailable, setDevLoginAvailable] = useState(false);

  const reload = useCallback(() => {
    setLoading(true);
    setError(null);
    api
      .me()
      .then((res) => {
        setUser(res.user);
        setDevLoginAvailable(res.devLoginAvailable);
      })
      .catch((e: unknown) => {
        setUser(null);
        setError(e instanceof ApiError ? e.message : "載入失敗。");
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <AuthContext.Provider value={{ user, loading, error, devLoginAvailable, reload }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
